module.exports = __webpack_public_path__ + "img/pagNext.d862184a.svg";